import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://amdxqzbbjvklfgixiqhs.supabase.co';
const supabaseAnonKey = 'sb_publishable_DyKzA10MmJZcWK3fesJmAQ_ppF55e4Z';

// DEV-ONLY: localhost/?poolPreview swaps in an in-memory fake so the Pools
// screens can be previewed without touching the real database.
// In a production build NODE_ENV is 'production', so this branch is removed.
export const isPoolPreview =
  process.env.NODE_ENV === 'development' &&
  typeof window !== 'undefined' &&
  new URLSearchParams(window.location.search).has('poolPreview');

export const supabase = isPoolPreview
  ? require('./dev/fakeSupabase').createFakeSupabase()
  : createClient(supabaseUrl, supabaseAnonKey);
